import React from 'react';
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function NestedList(props) {
  const classes = useStyles();
   //onClick={() => props.history.push('/user/profile/')}
  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      
      className={classes.root}
    >
      <Link to='/v2/user/profile' style={{textDecoration: 'none', color: (props.themeType === 'dark' ? '#FFF' : '#000'), cursor : 'pointer',
        }}>
        <ListItem button  >
          <ListItemIcon>
           <AccountCircle/>
          </ListItemIcon>
          <h5>My Profile</h5>
          
        </ListItem>
      </Link>
      
      
      <Link to='/v2/user/logout' style={{textDecoration: 'none', color: (props.themeType === 'dark' ? '#FFF' : '#000'), cursor : 'pointer',
        }}>
      <ListItem button>
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <h5>Logout</h5>
      </ListItem>
      </Link>
    </List>
  );
}
